import React from 'react';
import keyMapping from 'ub/ui/key-mapping';
import { stripScripts } from 'ub/utils';

/**
* TODO: Turn this into the "input" component and make it more composable
* also refer to input-field.jsx
* See: PB-2320
**/

export default class DropdownInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {value: props.value};
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onUserInput = this.onUserInput.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onFocus = this.onFocus.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({value: nextProps.value});
  }

  onUserInput(ev) {
    this.setState({value: ev.target.value.trim()});
  }

  onKeyDown(ev) {
    if (ev.which === keyMapping.RETURN_KEY) {
      ev.preventDefault();
      ev.target.blur();
    }

    return true;
  }

  onBlur(ev0) {
    const ev = ev0;
    ev.target.value = stripScripts(ev0.target.value);
    this.props.changeHandler(ev.target.value);
  }

  onFocus(ev) {
    window.editor.keyController.requestFocus(ev.target);
  }

  render() {
    return (
      <input
        maxLength={this.props.maxLength}
        className='dropdown-input'
        value={this.state.value}
        onChange={this.onUserInput}
        onKeyDown={this.onKeyDown}
        onBlur={this.onBlur}
        onFocus={this.onFocus}
      />
    );
  }
}

DropdownInput.propTypes = {
  changeHandler: React.PropTypes.func,
  maxLength: React.PropTypes.number,
  value: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/dropdown/dropdown-input.jsx